// extracted by mini-css-extract-plugin
export default {"splashContainer":"Splash_splashContainer__xqLAi","splashCard":"Splash_splashCard__oEiGS","inputText":"Splash_inputText__Eb1Bw","submitButton":"Splash_submitButton__AyAO-"};